<!-- PdfViewer.vue -->
<template>
  <div class="pdf-viewer-container">
    <div class="pdf-viewer">
      <canvas 
        v-for="page in pages" 
        :key="page" 
        :ref="`canvas-${page}`"
        class="pdf-page"
      ></canvas>
    </div>
  </div>
</template>


<script>
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf'
import 'pdfjs-dist/legacy/web/pdf_viewer.css'

// 在mounted前初始化Worker
pdfjsLib.GlobalWorkerOptions.workerSrc = 
 `${process.env.BASE_URL}utils/pdf.worker.min.js`


export default {
  props: ['src'],
  data() {
    return {
      pages: 0,
      pdfDocument: null
    }
  },
  async mounted() {
   try {

      if(this.pdfDocument) {
        await this.pdfDocument.destroy()
        this.pdfDocument = null
      }


      const container = this.$el
      const loadingTask = pdfjsLib.getDocument({
        url: this.src,
        cMapUrl: process.env.NODE_ENV === 'production' 
        ? `${process.env.BASE_URL}cmaps/` 
        : '/cmaps/',
        cMapPacked: true
      })
      
      this.pdfDocument = await loadingTask.promise
      this.pages = this.pdfDocument.numPages
      
      // 先预加载所有页面尺寸
      const pageDimensions = []
      for (let i = 1; i <= this.pages; i++) {
        const page = await this.pdfDocument.getPage(i)
        const viewport = page.getViewport({ scale: 1 })
        pageDimensions.push({
          width: viewport.width,
          height: viewport.height
        })
      }

      // 计算最大宽高比
      const maxAspectRatio = Math.max(...pageDimensions.map(d => d.width / d.height))
      const containerAspect = container.clientWidth / container.clientHeight
      let scale
      for (let pageNum = 1; pageNum <= this.pages; pageNum++) {
        const page = await this.pdfDocument.getPage(pageNum)
        const viewport = page.getViewport({ scale: 1 })
        
        // 智能缩放策略
        
        if (maxAspectRatio > containerAspect) {
          // 以宽度为基准
          scale = container.clientWidth / viewport.width
        } else {
          // 以高度为基准
          scale = (container.clientHeight - 40) / viewport.height
        }
        
        // 限制最小缩放
        scale = Math.max(scale, 0.8)

        scale = 0.7
        
        const scaledViewport = page.getViewport({ scale })
        
        const canvas = this.$refs[`canvas-${pageNum}`][0]
        const context = canvas.getContext('2d')
        
        // 设置画布尺寸
        canvas.height = scaledViewport.height
        canvas.width = scaledViewport.width
        
        // 渲染页面
        const renderContext = {
          canvasContext: context,
          viewport: scaledViewport
        }
        await page.render(renderContext).promise
      }
      
      // 动态调整容器高度
      const totalHeight = pageDimensions.reduce((sum, d) => 
        sum + (d.height * scale) + 30, 0)
      container.style.height = `${totalHeight}px`

    } catch (error) {
      console.error('PDF渲染失败:', error)
    }
  },
  beforeDestroy() {

    if (this.pdfDocument) {
      this.pdfDocument.destroy()
      this.pdfDocument = null
    }
    // 释放对象URL
    if (this.src.startsWith('blob:')) {
      URL.revokeObjectURL(this.src)
    }
  }
}
</script>

<style scoped>
/* 新增外层容器控制最大高度 */
.pdf-viewer-container {
  width: 90%;
  overflow-y: auto;
  padding: 10px;
  background: #f8f8f8;
  border-radius: 4px;
  box-shadow: inset 0 0 8px rgba(0,0,0,0.05);
}

.pdf-viewer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
}

.pdf-page {
  display: block;
  width: 100% !important;
  height: auto !important;
  margin: 15px auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  background: white;
  border: 1px solid #e0e0e0;
  transition: transform 0.2s;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .pdf-viewer-container {
    padding: 5px;
  }
  
  .pdf-page {
    margin: 10px auto;
    box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  }
}

</style>